// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
let define;
let is_node = typeof module=='object' && module.exports;
if (is_node)
    define = require('../../../util/require_node.js').define(module, '..');
else
    define = self.define;
define(['react', 'lodash4', '/util/string.js', '/www/util/pub/urlp.js',
    '/www/util/pub/pure_component.js', '/www/lum/pub/util/ga.js',
    '/www/util/pub/react_hooks.js'],
    (React, _, string, urlp, Pure_component, ga_util, react_hooks)=>
{
const E = {};
const {qw} = string;
const {use_context} = react_hooks;
const {assign} = Object;

E.url2ga_id = url=>new urlp.Urlp({url}).pathname.split('/').splice(1).join('_')
    .toLowerCase();

const ga_id_from_props = props=>props.ga_id || props.id;

const suf = {click: 'clicked', hover: 'hovered', check: 'checked',
    uncheck: 'unchecked', change: 'changed', open: 'opened', close: 'closed',
    focus: 'focused', select: 'selected'};
const evt_types = Object.entries({
    click: {suf: suf.click},
    hover: {suf: suf.hover},
    zbtn_click: {suf: suf.click},
    zbtn_hover: {suf: suf.hover},
    btn_icon_click: {suf: suf.click},
    btn_icon_hover: {suf: suf.hover},
    zlink_click: {suf: suf.click},
    zlink_hover: {suf: suf.hover},
    checkbox_check: {suf: suf.check},
    checkbox_uncheck: {suf: suf.uncheck},
    checkbox_hover: {suf: suf.hover},
    checkbox_grp_change: {suf: suf.change},
    radio_select: {suf: suf.select},
    date_picker_hover: {suf: suf.hover},
    date_picker_open: {suf: suf.open},
    date_picker_change: {suf: suf.change},
    date_picker_range_hover: {suf: 'range_'+suf.hover},
    date_picker_range_click: {suf: 'range_'+suf.click},
    date_picker_range_change: {suf: 'range_'+suf.change},
    box_collapsible_open: {suf: suf.open},
    box_collapsible_close: {suf: suf.close},
    input_hover: {suf: suf.hover},
    input_focus: {suf: suf.focus},
    input_change: {suf: suf.change, debounce: 300},
    dropdown_hover: {suf: suf.hover},
    dropdown_click: {suf: suf.click},
    dropdown_change: {suf: suf.change},
    input_list_change: {suf: suf.change},
}).reduce((acc, [id, config])=>assign(acc, {[id]: {id, ...config}}), {});

const debounced_triggers = {};
E.trigger = (type, ga_context, props={}, opt={})=>{
    const ga_id = opt.ga_id || ga_id_from_props(props);
    if (props.skip_ga || ga_context.skip_ga || !ga_id || !ga_context[type])
        return;
    if (!(type = evt_types[type]))
        return;
    const category = props.ga_category || ga_context.category || E.url2ga_id();
    const child_id = props.ga_child_id || ga_context.child_id;
    const action = _.uniq([child_id, ga_id, type.suf]).filter(Boolean)
        .join('_');
    if (!type.debounce)
        return void ga_util.gtm_ga_event(category, action);
    let debounced_fn, debounced_key = [type.id, category, action].join('_');
    if (!(debounced_fn = debounced_triggers[debounced_key]))
    {
        debounced_triggers[debounced_key] = debounced_fn = _.debounce(ga_util
            .gtm_ga_event, type.debounce, {leading: false, trailing: true});
    }
    debounced_fn(category, action);
};

E.ga_event = (category, action, label)=>
    ga_util.gtm_ga_event(category, action, label);

const _hook_fn = (fn, type, ga_context, props={}, opt={})=>(...args)=>{
    E.trigger(type, ga_context, props, opt);
    return (fn || _.noop)(...args);
};

E.hook_fn = (fn, type, props={}, opt={})=>{
    if (typeof fn=='string')
    {
        opt = props;
        props = type;
        type = fn;
        fn = null;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const ga_context = use_context(E.Ga_context);
    if (opt.skip) // done to preserve React hook call order
        return;
    return _hook_fn(fn, type, ga_context, props, opt);
};

E.child_context = (child_id, ga_context, extra)=>assign({}, ga_context,
    {child_id: [ga_context.child_id, child_id].filter(Boolean).join('_')},
    extra);

// disable evts by default so will send ga only where a custom provider is set
E.Ga_context = React.createContext(Object.keys(evt_types).reduce((acc, p)=>
    assign(acc, {[p]: false}), {category: ''}));

E.build_context = (category, opt={})=>_.difference(Object.keys(evt_types),
    opt.disable).reduce((acc, e)=>assign(acc, {[e]: true}), {
    category: category || E.url2ga_id()});

E.with_ga = Comp=>class With_ga extends Comp {
    static contextType = E.Ga_context;
    constructor(props, context){
        super(props, context);
        _.bindAll(this, qw`ga_hook_fn ga_trigger`);
    }
    ga_hook_fn(fn, type, opt){
        if (typeof fn=='string')
        {
            opt = type;
            type = fn;
            fn = null;
        }
        return _hook_fn(fn, type, this.context, this.props, opt);
    }
    ga_trigger(type, opt){
        return E.trigger(type, this.context, this.props, opt);
    }
    ga_event(category, action, label){
        E.ga_event(category || this.context.category, action, label);
    }
    get ga_id(){ return ga_id_from_props(this.props); }
    get ga_context(){ return this.context; }
};

E.with_ga_child = (Comp, child_id)=>{
    const With_ga = E.with_ga(Comp);
    return class With_ga_child extends Pure_component {
        static contextType = E.Ga_context;
        render(){
            const _child_id = ga_id_from_props(this.props) || child_id;
            const ga_context = E.child_context(_child_id, this.context,
                {skip_ga: !_child_id});
            return <E.Ga_context.Provider value={ga_context}>
                <With_ga {...this.props}/>
                </E.Ga_context.Provider>;
        }
    };
};

return E; }); // eslint-disable-line
